module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/wechat_tips.96015.png";